/// <amd-module name="InstantSearch/Shared/Services/WorkItemTrackingDataProviderService" />

import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";
import { WorkItemTrackingDataProvider } from "Wit/UI/Data";

export interface IWorkItemTrackingDataProviderService extends IVssService {
    getDataProvider(): WorkItemTrackingDataProvider;
}

class WorkItemTrackingDataProviderService extends VssService implements IWorkItemTrackingDataProviderService {
    private _dataProvider: WorkItemTrackingDataProvider;

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
        this._dataProvider = new WorkItemTrackingDataProvider(pageContext);
    }

    public getDataProvider(): WorkItemTrackingDataProvider {
        return this._dataProvider;
    }
}

Services.add("IWorkItemTrackingDataProviderService", { serviceFactory: WorkItemTrackingDataProviderService });
